<div>
  <div class="row">
    <div class="offset-lg-2"></div>

    <div class="col-lg-8 col-md-12">
      <div class="card">
        <div class="card-body">
          <form [formGroup]="form" (submit)="submit()">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="firstName">First Name</label>
                  <input
                    type="text"
                    class="form-control"
                    formControlName="firstName"
                    [ngClass]="getValidationClass('firstName')" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="firstName">Last Name</label>
                  <input
                    type="text"
                    class="form-control"
                    formControlName="lastName"
                    [ngClass]="getValidationClass('lastName')" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="email">Email</label>
                  <input
                    type="text"
                    class="form-control"
                    formControlName="email"
                    [ngClass]="getValidationClass('email')" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="email">Title</label>
                  <input
                    type="text"
                    class="form-control"
                    formControlName="title"
                    [ngClass]="getValidationClass('title')" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="email">Rec letter email</label>
                  <input
                    type="text"
                    class="form-control"
                    formControlName="recLetterEmail"
                    [ngClass]="getValidationClass('recLetterEmail')" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="email">Phone</label>
                  <input
                    type="text"
                    class="form-control"
                    formControlName="phone"
                    [ngClass]="getValidationClass('phone')" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="active">Active</label>
                  <input type="checkbox" style="width: 30px" class="form-control" formControlName="active" />
                </div>
              </div>
            </div>

            <div class="row" *ngIf="roles">
              <div class="col-md-12">
                <label>Roles</label>
                <table>
                  <tbody>
                    <ng-container *ngFor="let role of roles">
                      <!-- <tr class="permission-group">
                                                <td>
                                                    <button type="button" class="btn btn-sm"
                                                        (click)="toggleGroup(group)"><i style="font-size: 18px;"
                                                            class="fa fa-toggle-down"></i></button>
                                                </td>
                                                <td colspan="2">{{group}}</td>
                                            </tr> -->
                      <tr class="permission">
                        <td>
                          <input
                            [disabled]="!canEdit"
                            type="checkbox"
                            [(ngModel)]="role.checked"
                            [ngModelOptions]="{ standalone: true }" />
                        </td>
                        <td style="font-weight: bold">{{ role.name }}</td>
                        <td>{{ role.description }}</td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>

            <br />

            <div class="row" *ngIf="canEdit">
              <div class="col-md-12">
                <button class="btn btn-primary" [disabled]="!form.valid">Save</button>&nbsp;
                <button *ngIf="user.id" class="btn btn-outline-primary" (click)="sendResetLink($event)">
                  Send password reset link
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
